import { DateTime } from 'luxon';
import { IntlShape } from 'react-intl';

import { Period } from '../types';

const PERIODS: { [key in Period]: string } = {
  yesterday: 'purchases.labels.yesterday',
  'this-week': 'purchases.labels.this-week',
  'last-week': 'purchases.labels.last-week',
  'this-month': 'purchases.labels.this-month',
  'last-month': 'purchases.labels.last-month',
  custom: 'purchases.labels.custom',
};

export function getCSVFileName(prefixFileName: string, downloadPeriod: Period, intl: IntlShape) {
  const fileName = intl.formatMessage(
    { id: 'purchases.csv.filename' },
    {
      prefix: prefixFileName,
      period: intl.formatMessage({ id: PERIODS[downloadPeriod] }),
      date: DateTime.local().toISODate(),
    },
  );
  return `${fileName}.csv`;
}

export function getCSVFileNameV2(prefixFileName: string, intl: IntlShape) {
  const fileName = intl.formatMessage(
    { id: 'purchases.csv.filename' },
    {
      prefix: prefixFileName,
      period: 'custom',
      date: DateTime.local().toISODate(),
    },
  );
  return `${fileName}.csv`;
}
